import PrimaryButton from "Components/atoms/buttons/primary-button"
import SearchFormContainer from "Components/atoms/containers/search-form-container"
import SearchSelect from "Components/molecule/inputs/search-select"
import MultiSelect from "Components/molecule/inputs/multi-select"
import { SelectOption } from "../../../molecule/inputs/select-input"
import CheckboxInput from "Components/molecule/inputs/checkbox-input"

interface SearchBudgetActualsProps {
    branches: SelectOption[]
    departments: SelectOption[]
    financialYears: SelectOption[]

    selectedBranches: SelectOption[]
    selectedDepartments: SelectOption[]
    selectedYear: string
    showDetail: boolean

    onChangeBranches: (v: SelectOption[]) => void
    onChangeDepartments: (v: SelectOption[]) => void
    onChangeYear: (v: SelectOption | null) => void
    onClear: () => void
}

const SearchBudgetActualsForm = ({
    branches,
    departments,
    financialYears,
    selectedBranches,
    selectedDepartments,
    selectedYear,
    showDetail,
    onChangeBranches,
    onChangeDepartments,
    onChangeYear,
    onClear
}: SearchBudgetActualsProps) => {
    return (
        <SearchFormContainer
            inputs={
                <>
                    <SearchSelect
                        containerStyle={{
                            flex: "1 50px",
                            minWidth: '100px'
                        }}
                        className="col"
                        label="Fiscal Year"
                        options={financialYears}
                        value={selectedYear}
                        onChange={onChangeYear}
                        placeholder="Select year"
                    />

                    <MultiSelect
                        containerStyle={{
                            flex: "3 150px"
                        }}
                        className="col"
                        label="Branch"
                        options={branches}
                        value={selectedBranches}
                        onChange={onChangeBranches}
                        placeholder="Select branches"
                    />

                    <MultiSelect
                        containerStyle={{
                            flex: "12 250px"
                        }}
                        className="col"
                        label="Department"
                        options={departments}
                        value={selectedDepartments}
                        onChange={onChangeDepartments}
                        placeholder="Select departments"
                    />
                </>
            }
            clearSearchButton={
                <PrimaryButton onClick={onClear}>
                    Clear Search
                </PrimaryButton>
            }
        />
    )
}

export default SearchBudgetActualsForm
